module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.iterators.js
// module id = 26
// module chunks = 0